// import { Paperclip, Mail, X } from 'lucide-react';
// import { useState } from 'react';

// const EmailFieldsBar = ({ 
//   activeField, 
//   setActiveField, 
//   sendToCcBccSubject,
//   handleSaveField,
//   handleAttachments 
// }) => {
//   const [tempValue, setTempValue] = useState('');

//   const fields = [
//     { key: 'fromName', label: 'Name', placeholder: 'Enter Sender Name' },
//     { key: 'fromEmail', label: 'From', placeholder: 'Enter Sender email' },
//     { key: 'sendTo', label: 'To', placeholder: 'Enter recipient email' },
//     { key: 'sendToCc', label: 'Cc', placeholder: 'Enter Cc emails' },
//     { key: 'sendToBcc', label: 'Bcc', placeholder: 'Enter Bcc emails' },
//     { key: 'subjectFor', label: 'Subject', placeholder: 'Enter email subject' }
//   ];

//   const emails = ["noreply@eduskillsfoundation.org", "noreply@eduskillsacademy.org", "noreply@eduskillscommunity.org"]

//   const handleFieldClick = (fieldKey) => {
//     setTempValue(sendToCcBccSubject[fieldKey] || '');
//     setActiveField(fieldKey);
//   };

//   const handleSave = () => {
//     if (activeField) {
//       handleSaveField(activeField, tempValue);
//     }
//   };

//   const handleCancel = () => {
//     setActiveField(null);
//     setTempValue('');
//   };

//   return (
//     <div className="bg-white rounded-lg shadow-sm p-2">
//       {/* Field Pills and Attachment Button */}
//       <div className="flex items-center gap-2">
//         {fields.map(field => (
//           <button
//             key={field.key}
//             onClick={() => handleFieldClick(field.key)}
//             className={`px-2 py-1 text-xs rounded transition ${
//               sendToCcBccSubject[field.key]
//                 ? 'bg-blue-100 text-blue-700 hover:bg-blue-200'
//                 : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//             } ${activeField === field.key ? 'ring-2 ring-blue-400' : ''}`}
//             title={sendToCcBccSubject[field.key] || `Set ${field.label}`}
//           >
//             {field.label}
//             {sendToCcBccSubject[field.key] && (
//               <span className="ml-1 text-blue-500">•</span>
//             )}
//           </button>
//         ))}
        
//         {/* Attachment Button */}
//         <button
//           onClick={handleAttachments}
//           className="p-1.5 rounded bg-gray-100 hover:bg-gray-200 text-gray-700 transition"
//           title="Attachments"
//         >
//           <Paperclip className="w-3.5 h-3.5" />
//         </button>
//       </div>

//       {/* Expanded Editor for Active Field */}
//       {activeField && (
//         <div className="border-t pt-2 space-y-2">
//           <div className="flex items-center justify-between">
//             <label className="text-xs font-medium text-gray-700">
//               {fields.find(f => f.key === activeField)?.label}
//             </label>
//             <button
//               onClick={handleCancel}
//               className="text-gray-400 hover:text-gray-600"
//             >
//               <X className="w-3 h-3" />
//             </button>
//           </div>
          
//           <textarea
//             value={tempValue}
//             onChange={(e) => setTempValue(e.target.value)}
//             placeholder={fields.find(f => f.key === activeField)?.placeholder}
//             className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
//             rows={2}
//             autoFocus
//           />
          
//           <div className="flex gap-2">
//             <button
//               onClick={handleSave}
//               className="flex-1 px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition"
//             >
//               Save
//             </button>
//             <button
//               onClick={handleCancel}
//               className="px-3 py-1 text-xs bg-gray-200 text-gray-700 rounded hover:bg-gray-300 transition"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default EmailFieldsBar;


import { Paperclip, Mail, X } from 'lucide-react';
import { useState } from 'react';

const EmailFieldsBar = ({ 
  activeField, 
  setActiveField, 
  sendToCcBccSubject,
  handleSaveField,
  handleAttachments 
}) => {
  const [tempValue, setTempValue] = useState('');

  const fields = [
    { key: 'fromName', label: 'Name', placeholder: 'Enter Sender Name' },
    { key: 'fromEmail', label: 'From', placeholder: 'Select Sender email', isDropdown: true },
    { key: 'sendTo', label: 'To', placeholder: 'Enter recipient email' },
    { key: 'sendToCc', label: 'Cc', placeholder: 'Enter Cc emails' },
    { key: 'sendToBcc', label: 'Bcc', placeholder: 'Enter Bcc emails' },
    { key: 'subjectFor', label: 'Subject', placeholder: 'Enter email subject' }
  ];

  const emails = [
    "noreply@eduskillsfoundation.org", 
    "noreply@eduskills.academy", 
    "noreply@eduskills.community",
    "noreply@eduskills.international"
  ];

  const handleFieldClick = (fieldKey) => {
    setTempValue(sendToCcBccSubject[fieldKey] || '');
    setActiveField(fieldKey);
  };

  const handleSave = () => {
    if (activeField) {
      handleSaveField(activeField, tempValue);
    }
  };

  const handleCancel = () => {
    setActiveField(null);
    setTempValue('');
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-2">
      {/* Field Pills and Attachment Button */}
      <div className="flex items-center gap-2">
        {fields.map(field => (
          <button
            key={field.key}
            onClick={() => handleFieldClick(field.key)}
            className={`px-2 py-1 text-xs rounded transition ${
              sendToCcBccSubject[field.key]
                ? 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            } ${activeField === field.key ? 'ring-2 ring-blue-400' : ''}`}
            title={sendToCcBccSubject[field.key] || `Set ${field.label}`}
          >
            {field.label}
            {sendToCcBccSubject[field.key] && (
              <span className="ml-1 text-blue-500">•</span>
            )}
          </button>
        ))}
        
        {/* Attachment Button */}
        <button
          onClick={handleAttachments}
          className="p-1.5 rounded bg-gray-100 hover:bg-gray-200 text-gray-700 transition"
          title="Attachments"
        >
          <Paperclip className="w-3.5 h-3.5" />
        </button>
      </div>

      {/* Expanded Editor for Active Field */}
      {activeField && (
        <div className="border-t pt-2 space-y-2">
          <div className="flex items-center justify-between">
            <label className="text-xs font-medium text-gray-700">
              {fields.find(f => f.key === activeField)?.label}
            </label>
            <button
              onClick={handleCancel}
              className="text-gray-400 hover:text-gray-600"
            >
              <X className="w-3 h-3" />
            </button>
          </div>
          
          {/* Conditional Render: Dropdown for fromEmail, Textarea for others */}
          {activeField === 'fromEmail' ? (
            <select
              value={tempValue}
              onChange={(e) => setTempValue(e.target.value)}
              className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
              autoFocus
            >
              <option value="">Select an email</option>
              {emails.map((email) => (
                <option key={email} value={email}>
                  {email}
                </option>
              ))}
            </select>
          ) : (
            <textarea
              value={tempValue}
              onChange={(e) => setTempValue(e.target.value)}
              placeholder={fields.find(f => f.key === activeField)?.placeholder}
              className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
              rows={2}
              autoFocus
            />
          )}
          
          <div className="flex gap-2">
            <button
              onClick={handleSave}
              className="flex-1 px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition"
            >
              Save
            </button>
            <button
              onClick={handleCancel}
              className="px-3 py-1 text-xs bg-gray-200 text-gray-700 rounded hover:bg-gray-300 transition"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmailFieldsBar;
